// utils/stageUtils.js
export const stageColorMap = {
    'New': 'blue',
    'Call Back': 'orange',
    'Voice Mail': 'purple',
    'Follow-Up': 'geekblue',
    'Quoted': 'gold',
    'Negotiation': 'cyan',
    'Pending Payment': 'red',
    'Payment Completed': 'green',
    'Sales Made': 'success',
    'Part Not Available': 'magenta',
    'Wrong Number': 'red',
    'Not Interested': 'red',
    'Hang Up': 'red',
    'Fake': 'red',
    'Test Lead': 'gray',
    'Error': 'volcano'
};